export const makeTestId = (...labels) => {
  if (!labels.length) {
    throw new Error('Test ID include at least one label');
  }

  return `fe-shared-components-${labels.join('-')}`;
};

export const getTrackingSource = slug => {
  switch (slug) {
    case 'shop':
      return 'shop';
    case 'manage':
      return 'manage';
    case 'track-gifts':
      return 'gift tracker';
    case 'registry-url':
    case 'registry-note':
    case 'shipping-address':
    case 'cash-funds':
      return 'settings';
    default:
      return null;
  }
};

// Takes a number and converts it into a currency string including dollar sign and commas for thousands.
// e.g. 1234 -> $1,234
// e.g. 1234.56 -> $1,234.56
export function formatAsCurrency(num, keepNonZeroDecimals = true) {
  const formatted = num.toLocaleString('en-US', {
    currency: 'USD',
    style: 'currency',
    maximumFractionDigits: 2,
  });

  const parts = formatted.split('.');

  if (!keepNonZeroDecimals && parts[1] === '00') {
    return parts[0];
  }

  return formatted;
}
